import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "safe-horizontal-container" }
const _hoisted_2 = { class: "category-wizard-mobile__header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "category-wizard-mobile__meta-left" }
const _hoisted_5 = { class: "category-wizard-mobile__meta-right" }
const _hoisted_6 = { class: "category-wizard-mobile__title-row" }
const _hoisted_7 = { class: "category-wizard-mobile__category-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryColorBar = _resolveComponent("CategoryColorBar")!
  const _component_ElTag = _resolveComponent("ElTag")!

  return (_ctx.currentStepData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle(`--stepColor: #${_ctx.currentStepData.color}`),
        class: "category-wizard-mobile"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "category-wizard-mobile__meta",
              role: "status",
              "aria-live": "polite",
              "aria-label": _ctx.a11yStatusLabel
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.stepCountLabel), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.completionLabel), 1)
            ], 8, _hoisted_3),
            _createVNode(_component_CategoryColorBar, {
              "active-step": _ctx.currentStep,
              class: "category-wizard-mobile__bar"
            }, null, 8, ["active-step"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.currentStepData.label), 1),
              (_ctx.showLevelTag)
                ? (_openBlock(), _createBlock(_component_ElTag, {
                    key: 0,
                    size: _ctx.$screen.smDown ? 'small' : 'default',
                    class: "category-wizard-mobile__category-level",
                    "data-tag-type": "grey",
                    effect: "plain"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("common.levelTag", { level: _ctx.selectedStepData?.level })), 1)
                    ]),
                    _: 1
                  }, 8, ["size"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}